export default __webpack_public_path__ + "static/media/logo.06f3cbf1.png";